import type { AttributeEditModeConfig } from '@source-components-react/types';
import {
  DEFAULT_DIVIDER_STYLE,
  DEFAULT_DIVIDER_THICKNESS,
  DIVIDER_STYLE_ATTRIBUTE,
  DIVIDER_THICKNESS_ATTRIBUTE,
} from './divider-attributes';

/**
 * Both settings the divider offers, in the order the Modify drawer shows them.
 *
 * Order is not cosmetic. The drawer renders these top to bottom and the
 * documentation registry asserts its pages match that sequence, so moving an
 * entry here moves it in both places at once.
 */
export const attributeEditModeConfigs: AttributeEditModeConfig[] = [
  {
    name: DIVIDER_STYLE_ATTRIBUTE,
    heading: 'Line Style',
    subHeading:
      'Whether the rule is unbroken or broken up. Colour comes from Text Color on the column, for 3 different device resolutions',
    defaultValues: { all: DEFAULT_DIVIDER_STYLE },
  },
  {
    name: DIVIDER_THICKNESS_ATTRIBUTE,
    heading: 'Thickness',
    subHeading: 'How heavy the rule is, from a hairline to a band',
    defaultValues: { all: DEFAULT_DIVIDER_THICKNESS },
  },
];
